import axiosInstance from "@/api/axiosInstanceNode";

export const getOpenAIKeyMeta = () =>
  axiosInstance.get("/settings/openai-key").then((r) => r.data);

export const setOpenAIKey = (api_key) =>
  axiosInstance.post("/settings/openai-key", { api_key }).then((r) => r.data);

export const deleteOpenAIKey = () =>
  axiosInstance.delete("/settings/openai-key").then((r) => r.data);
